import { SB } from '@play-co/replicant';
import { getLocaleConfig } from '../../creatives/text';
import { preEntryInviteCreatives } from '../preEntry.ruleset';
import {
  createFlexContainer,
  createFlexMessageTemplate,
  createOpenGameAction,
} from './utils';

/** Render an existing invite creative as an OA message with a game-entry link. */
export const preEntryInviteMessage = createFlexMessageTemplate(
  SB.object({
    creative: SB.tuple(preEntryInviteCreatives),
    locale: SB.tuple(['en', 'ja']),
  }),
  ({ creative, locale }, payload, api) => {
    // Reuse the pet-free entry prompt and invite artwork, not social-share sender data.
    const text = getLocaleConfig(locale).spawnPet.open.text;
    return createFlexContainer(text, {
      type: 'bubble',
      size: 'giga',
      hero: {
        type: 'image',
        url: api.getAssetPath(creative),
        size: 'full',
        aspectRatio: '1:1',
        aspectMode: 'cover',
        action: createOpenGameAction(text, payload),
      },
    });
  },
);
